import { MOKA_SERVICE_HOST } from '../constants';

export const CAPITAL_CONSENT_URL = `${MOKA_SERVICE_HOST}/capital/v1/consents`;
export const GET_DASHBOARD_CAPITAL = `${MOKA_SERVICE_HOST}/capital/v1/submissions`;
export const CAPITAL_PREAPPROVALS_URL = `${MOKA_SERVICE_HOST}/capital/v1/preapprovals`;
export const PUT_SIGIN_CONTRACT_CLICK = (documentId) =>
  `${MOKA_SERVICE_HOST}/capital/v1/documents/${documentId}/views`;
export const FINAL_APPROVALS = `${MOKA_SERVICE_HOST}/capital/v1/finalapprovals`;
export const ELIGIBLE_CHECK = `${MOKA_SERVICE_HOST}/capital/v1/loan-eligibilities`;
export const COMMONWEALTH_PROVINCES = `${MOKA_SERVICE_HOST}/capital/v1/commonwealth/provinces`;
export const COMMONWEALTH_CITIES = `${MOKA_SERVICE_HOST}/capital/v1/commonwealth/cities`;
export const CAPITAL_TABULAR_MENUS = [
  {
    tabId: 'product',
    label: 'Produk',
    dataTestId: 'sub-product',
  },
  {
    tabId: 'status',
    label: 'Status',
    dataTestId: 'sub-status',
  },
];
export const CAPITAL_KOINWORKS_SUPPORTED_LOCATION = `${MOKA_SERVICE_HOST}/capital/v1/lenders/koinworks/supported-locations`;

export const MOKA_CAPITAL_SERVICE = `${MOKA_SERVICE_HOST}/capital`;
